import { Button, MultiSelect } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { BILLING_ENTITY_OPTIONS, type BillingEntityValue } from '@/pages/Billing/utils'
import {
  ACCOUNTING_VISIT_STATUS_OPTIONS,
  type AccountingFilters,
  type AccountingVisitStatusValue,
} from './state'

type FilterOptions = {
  providers: { id: string; name: string }[]
  payers: string[]
  states: string[]
}

export function ReportFilters({
  filters,
  onChange,
  options,
  onReset,
}: {
  filters: AccountingFilters
  onChange: (next: AccountingFilters) => void
  options: FilterOptions | undefined
  onReset: () => void
}) {
  const providerData = (options?.providers ?? []).map((provider) => ({
    value: provider.id,
    label: provider.name,
  }))

  return (
    <div className="flex flex-wrap items-end gap-3">
      <DatePickerInput
        label="Service date from"
        aria-label="Service date from"
        placeholder="MM/DD/YYYY"
        value={filters.dateFrom}
        onChange={(value) => onChange({ ...filters, dateFrom: value ?? '' })}
        valueFormat="MM/DD/YYYY"
        clearable
      />

      <DatePickerInput
        label="Service date through"
        aria-label="Service date through"
        placeholder="MM/DD/YYYY"
        value={filters.dateTo}
        onChange={(value) => onChange({ ...filters, dateTo: value ?? '' })}
        valueFormat="MM/DD/YYYY"
        clearable
      />

      <MultiSelect
        label="PC / legal entity"
        placeholder="All entities (consolidated)"
        data={[...BILLING_ENTITY_OPTIONS]}
        value={filters.billingEntities}
        onChange={(value) =>
          onChange({ ...filters, billingEntities: value as BillingEntityValue[] })
        }
        searchable
      />

      <MultiSelect
        label="Patient state at encounter"
        placeholder="All states"
        data={options?.states ?? []}
        value={filters.patientStates}
        onChange={(value) => onChange({ ...filters, patientStates: value })}
        searchable
      />

      <MultiSelect
        label="Provider"
        placeholder="All providers"
        data={providerData}
        value={filters.practitionerIds}
        onChange={(value) => onChange({ ...filters, practitionerIds: value })}
        searchable
      />

      <MultiSelect
        label="Payer"
        placeholder="All payers"
        data={options?.payers ?? []}
        value={filters.payerNames}
        onChange={(value) => onChange({ ...filters, payerNames: value })}
        searchable
      />

      <MultiSelect
        label="Visit status"
        placeholder="All visit statuses"
        data={[...ACCOUNTING_VISIT_STATUS_OPTIONS]}
        value={filters.visitStatuses}
        onChange={(value) =>
          onChange({ ...filters, visitStatuses: value as AccountingVisitStatusValue[] })
        }
        searchable
      />

      <Button variant="default" onClick={onReset}>
        Reset filters
      </Button>
    </div>
  )
}
